<template>
  <div class="centent">
    <div class="titlefont">
      <div class="titleAnimation">
        <div class="title">只要3个月 你也可以一样出类拔萃</div>
        <div class="desc">真项目才有好成绩 数据看得见</div>
      </div>
    </div>
    <div class="cont">
      <div class="">
        <div class="itemContes itemA">
          <div
            class="expectItems"
            @mouseover="twoMouseOver()"
            @mouseout="twoMouseOut()"
          >
            <ul>
              <li
                @click="traitCheckHandle(0)"
                :class="0 === navLiNum ? 'secondActive' : ''"
              >
                <div class="inconLeft GzIcon"></div>
                <div class="textRight">
                  <div class="title">广州新媒体3期</div>
                  <p class="desc">
                    学习3个月，Offer<span class="textDesc">13.4k</span>
                  </p>
                </div>
                <span class="rightIcon"></span>
              </li>
              <li
                @click="traitCheckHandle(1)"
                :class="1 === navLiNum ? 'secondActive' : ''"
              >
                <div class="inconLeft SzIcon"></div>
                <div class="textRight">
                  <div class="title">深圳新媒体17期</div>
                  <p class="desc">
                    学习3个月，Offer<span class="textDesc">18k</span>
                    <!-- 获赞<span class="textDesc" >233w+
                      </span> -->
                  </p>
                </div>
                <span class="rightIcon"></span>
              </li>
              <li
                @click="traitCheckHandle(2)"
                :class="2 === navLiNum ? 'secondActive' : ''"
              >
                <div class="inconLeft BjIcon"></div>
                <div class="textRight">
                  <div class="title">北京新媒体17期</div>
                  <p class="desc">
                    学习2个月，吸粉<span class="textDesc">5000+</span
                    >，每月盈利<span class="textDesc">2k-3k</span>
                  </p>
                </div>
                <span class="rightIcon"></span>
              </li>
              <li
                @click="traitCheckHandle(3)"
                :class="3 === navLiNum ? 'secondActive' : ''"
              >
                <div class="inconLeft SzIcon"></div>
                <div class="textRight">
                  <div class="title ">深圳新媒体18期</div>
                  <p class="desc">
                    学习1个月，吸粉<span class="textDesc">12W+</span>
                  </p>
                </div>
                <span class="rightIcon"></span>
              </li>
              <li
                @click="traitCheckHandle(4)"
                :class="4 === navLiNum ? 'secondActive' : ''"
              >
                <div class="inconLeft ShIcon"></div>
                <div class="textRight">
                  <div class="title">上海新媒体7期</div>
                  <p class="desc">
                    学习2个月，吸粉<span class="textDesc">19.4W+ </span> 获赞<span class="textDesc" >233W+
                      </span>
                  </p>
                </div>
                <span class="rightIcon"></span>
              </li>
            </ul>
          </div>
          <div class="stItem">
            <div class="shadeBg"></div>
            <div class="shade">
              <div :style="phonesty">
                <img src="./../images/guagnzhou3.jpg" />
                <img src="./../images/shenzhen17.jpg" />
                <img src="./../images/beijing17.jpg" />
                <img src="./../images/shenzhen18.png" />
                <img src="./../images/shanghai7.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      navLiNum: 0,
    };
  },
  computed: {
    phonesty() {
      let num = Number(this.navLiNum) * 300;

      return `transform: translateX(-${num / 3}%);transition: all 0.3s;`;
    },
  },
  created() {},
  mounted() {
    // 自动切换
    this.timer = setInterval(() => this.timerFunc(), 2000);
  },
  methods: {
    // 经过
    twoMouseOver: function () {
      clearInterval(this.timer);
    },
    // 离开
    twoMouseOut: function () {
      this.timer = setInterval(() => this.timerFunc(), 2000);
    },
    // 点击
    traitCheckHandle(index) {
      this.navLiNum = index;
    },
    // 封装自动切换定时器
    timerFunc() {
      this.navLiNum = this.navLiNum >= 4 ? 0 : this.navLiNum + 1;
    },
  },
};
</script>
<style src="./../style.scss" rel="stylesheet/scss" lang="scss" scoped></style>
<style lang="scss" scoped>
</style>
